import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
import { UnixTimestamp } from '../unix-timestamp';
export var PublishScoreInformation = /*#__PURE__*/function (_ValueObject) {
  _inherits(PublishScoreInformation, _ValueObject);

  var _super = _createSuper(PublishScoreInformation);

  function PublishScoreInformation() {
    _classCallCheck(this, PublishScoreInformation);

    return _super.apply(this, arguments);
  }

  _createClass(PublishScoreInformation, [{
    key: "publishedAt",
    get: function get() {
      return this.props.publishedAt;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.props.startTime;
    }
  }, {
    key: "endTime",
    get: function get() {
      return this.props.endTime;
    }
  }, {
    key: "note",
    get: function get() {
      return this.props.note;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return {
        publishedAt: this.publishedAt,
        startTime: this.startTime,
        endTime: this.endTime,
        description: this.note
      };
    }
  }, {
    key: "isOverdue",
    value: function isOverdue() {
      return this.endTime < UnixTimestamp.now();
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.publishedAt,
        argumentName: 'Published At'
      }, {
        argument: props.startTime,
        argumentName: 'Publish Score Start Time'
      }, {
        argument: props.endTime,
        argumentName: 'Publish Score End Time'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new PublishScoreInformation(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      if (!data) return Result.ok();
      var publishedAt = data.publishedAt,
          startTime = data.startTime,
          endTime = data.endTime,
          note = data.note;
      return this.create({
        publishedAt: publishedAt,
        startTime: startTime,
        endTime: endTime,
        note: note
      });
    }
  }]);

  return PublishScoreInformation;
}(ValueObject);